interface Window {
  dataLayer?: unknown[]
}

declare const window: Window

export const useDataLayer = () => {
  function push (...data: unknown[]) {
    if (typeof window === 'undefined') {
      // We are in a non-browser environment, e.g. server-side rendering
      return
    }
    if (!window.dataLayer) {
      window.dataLayer = []
    }
    window.dataLayer.push(...data)
  }

  // _data is indirectly used with `arguments` keyword
  function gtag (..._data: unknown[]) {
    if (typeof window === 'undefined') {
      // We are in a non-browser environment, e.g. server-side rendering
      return
    }
    if (!window.dataLayer) {
      window.dataLayer = []
    }
    // eslint-disable-next-line prefer-rest-params -- arguments is required for dataLayer.push
    window.dataLayer.push(arguments)
  }

  return {
    push,
    gtag
  }
}
